import React from 'react';
import { Link } from 'react-router-dom'; 
import load from './partials/load.svg';
import {registerLocale} from "react-datepicker";
import es from 'date-fns/locale/es';
import { toast } from 'react-toastify';
registerLocale('es',es);

const ItemsProduct = (props) => {
   const {inventario, index, remove, ver } = props;
   return (
		<tr key={index}>
         <td className="producto">{inventario.user.name}</td>
			<td className="precio">{inventario.sucursal.nombre}</td>
         <td className="codigo">{inventario.fecha}</td>
			<td className="operaciones text-left">
            <span className="icon-view" onClick={()=>ver(inventario.id)} title="ver"></span>
            <Link to={window.$api+'/inventario/descargar/'+inventario.id} className="icon-save" download="inventario.csv" title="Descargar"></Link>
            <span className="icon-trash" onClick={()=>remove(inventario.id)} title="ver"></span>
         </td>
		</tr>
	)
}

const Detalle = (props) => {
   const { open, inventario, ver } = props;
   let list = [];
   let sucursal = 'tienda';
   if( Array.isArray(inventario.productos) && inventario.productos.length > 0 ){
      inventario.productos.forEach((producto,index)=>{
            list.push(
               <tr key={index}>
                  <td>{producto.codigo}</td>
                  <td className="text-left">{producto.nombre}</td>
                  <td>{producto.stock}</td>
                  <td>{producto.cantidad}</td>
                  <td>{producto.precio}</td>
               </tr>
            );
         });
      sucursal = inventario.sucursal.nombre === 'Bodega' ? 'Bodega' : 'Tienda';
   }
   
   return (
      <div className={ open ? 'overlay show':'overlay'}>
			<div className="row content" style={{'width':'1000px'}}>
				<div className="modal_header">
					<h5>DETALLE</h5>
					<span className="close-pop-up" onClick={ver}>x</span>
				</div>
				<div className="modal_body">
					<div className="xs-12 sm-12 md-12 lg-12 no-padding">
                  { Object.entries(inventario).length !== 0 ? (
                     <table>
                        <thead>
                        <tr>
                           <th>Sucursal</th> 
                           <th>Usuario</th> 
                           <th>Fecha</th>
                           <th></th>
                        </tr>
                        </thead>
                        <tbody style={{height:'50px'}}>
                        <tr>
                           <td>{inventario.sucursal.nombre}</td>
                           <td>{inventario.user.name}</td>
                           <td>{inventario.fecha}</td>
                           <td>
                              <a href={window.$api+'/inventario/descargar/'+inventario.id} download={inventario.sucursal.id+"-inventario.csv"} className="btn-small-2">Descargar</a>
                           </td>
                        </tr>
                        </tbody>
                     </table>
                     ) :'' 
                  }

                  <div style={{'height':'400px','overflowY':'scroll'}}>
                     <table>
                        <thead>
                           <tr className="text-center">
                              <td>Código</td>
                              <td className="text-left">Nombre</td>
                              <td>Stock en {sucursal}</td> 
                              <td>Conteo en {sucursal}</td>
                              <td>Precio</td>
                           </tr>
                        </thead>
                        <tbody>
                           {list}
                        </tbody>
                     </table>
                  </div>
					</div>
				</div>
			</div>
		</div>
   );
}

class Inventarioadmin extends React.Component{
   constructor(props){
      super(props);
      this.state = {
         inventarios : [],
         inventariosDefault:[],
         sucursales: [],
         inventario : {},
         sucursalFilter : 0,
         cantidad : 0,
         load : false,
         search : '',
         success : false,
         message : '',
         opened : false,
         pagination : [],
         abrirDetalle : false,
         startDate : new Date()
      }
      this.sesion = JSON.parse( localStorage.getItem('sesion'));
   }
   componentDidMount(){
		fetch(window.$api+'/inventario')
		.then(res=>res.json())
		.then(res=>{
         const inventarios = res.inventarios;
         const inventariosDefault=res.inventarios;
         const sucursales = res.sucursales;
         // const pagination = res.pagination;
			this.setState({inventarios,inventariosDefault,sucursales});
		});
   }
	searchHandler = (e) =>{
      this.setState({ load : ! this.state.load });
      let sucursalFilter = parseInt(e.target.value);
      if( sucursalFilter ){
         fetch(window.$api+'/inventario/'+sucursalFilter)
         .then(res=>res.json())
         .then(res=>{
            const inventarios = res;
            const inventariosDefault = res;
            const load = ! this.state.load ;
            this.setState({inventarios,inventariosDefault,sucursalFilter,load});
         });
      }else{
         fetch(window.$api+'/inventario')
            .then(res=>res.json())
            .then(res=>{
               const inventarios = res.inventarios;
               const inventariosDefault=res.inventarios;
               const load = ! this.state.load ;
               this.setState({inventarios,inventariosDefault, load});
		   });
      }
   }
   
   verDetalle = (id) => {
      if( id > 0 ){
         const inventario = this.state.inventarios.find(e=>e.id===id);
         const abrirDetalle = !this.state.abrirDetalle;
         this.setState({inventario, abrirDetalle});
      }else{
         const abrirDetalle = !this.state.abrirDetalle;
         this.setState({abrirDetalle})
      }
   }
   onFetchSucursalDate = () => {
      const startDate = this.state.startDate;
      const options = { year : 'numeric', month : 'numeric', day : 'numeric'};
      const initDate = startDate.toLocaleDateString('es-Es', options);
      let fecha = initDate.split('/');
      if( fecha[1] < 9 ){
         fecha[1] = '0'+fecha[1];
      }
      console.log( this.state.sucursalFilter );
      fecha = fecha[0]+'-'+fecha[1]+'-'+fecha[2];
      if( this.state.sucursalFilter > 0 ){
         let load = ! this.state.load ;
         this.setState({load});
         fetch(window.$api+'/inventario/'+this.state.sucursalFilter+'/'+fecha)
         .then(res=>res.json())
         .then(res=>{
            const inventarios = res;
            const inventariosDefault = res;
            load = ! this.state.load ;
            this.setState({inventarios,inventariosDefault,load});
         });
      }else{
         let load = ! this.state.load ;
         this.setState({load});
         fetch(window.$api+'/inventario/NaN/'+fecha)
         .then(res=>res.json())
         .then(res=>{
            const inventarios = res;
            const inventariosDefault = res;
            load = ! this.state.load ;
            this.setState({inventarios,inventariosDefault,load});
         });
      }

   }
   remove = (sucursal_id) => {
      this.setState({ load : ! this.state.load });
      fetch(
         window.$api+'/inventario/'+sucursal_id,
         { method : 'DELETE' }
      )
      .then(res=>res.json())
		.then(res=>{
         const  array = this.state.inventariosDefault.slice();
         let inventariosDefault = array.filter(i=>i.id!==sucursal_id);
         let inventarios = inventariosDefault;
			this.setState({inventarios,inventariosDefault});
         this.setState({ load : ! this.state.load });
         toast.success('Registro eliminado con éxito');
		});
   }
   render(){
      let list = [];
      if( this.state.inventarios?.length ){
         this.state.inventarios.forEach((inventario, index)=>{
            if( inventario.user ){
               list.push(
                  <ItemsProduct 
                     key={index}
                     inventario={inventario}
                     handler={this.handler}
                     ver={this.verDetalle}
                     remove={this.remove}
                  />
               );
            }
			});
		}
      let pagination = [];
      let optionsTag = [];
      
      if( this.state.sucursales.length > 0){
         this.state.sucursales.forEach((item, index)=>{
            optionsTag.push(<option key={index} value={item.id}>{item.nombre}</option>)
         })
      }

      return (
         <div className="wrap-module">
            <h1>Inventario</h1>
         <div className="wrap-content">
            <div className="xs-12 sm-12 md-12 lg-12"><br/></div>
            <div className="xs-12 sm-3 md-3 lg-3">
               <label>Selecciona una sucursal</label>
               <select onChange={this.searchHandler}>
                  <option> - Todos -</option>
                  {optionsTag}
               </select>
            </div>
            <div className="xs-12 sm-5 md-4 lg-4">
               <Detalle
                  open={this.state.abrirDetalle}
                  inventario={this.state.inventario}
                  ver={this.verDetalle}
               />
            </div>
            <div className="xs-12 sm-12 md-12 lg-12">{this.state.message}</div>
            <div className="xs-12 sm-12 md-12 lg-12">
               <br/>
               <table>
                  <thead key={1}>
                     <tr>
                        <th className="th">Auditor</th><th className="th">Sucursal</th>
                        <th className="th">Fecha y Hora</th><th>Acción</th>
                     </tr>
                  </thead>
                  <tbody key={2}>{this.state.inventarios?.length ? list : ''}</tbody>
                  <tfoot>
                     <tr>
                        <th></th>
                        <th colSpan='4'><ul className='pagination'>{pagination}</ul></th>
                     </tr>
                  </tfoot>
               </table>
            </div>
         </div>
         <div className={this.state.success ? 'overlay confirm show' : 'overlay confirm' }>
            <div className="alert text-center">
               <h3>Operación exitosa</h3>
               <div className="btn btn-green" onClick={this.closeSuccess}>Aceptar</div>
            </div>
         </div>
            <div className={this.state.load?'load show':'load'}><img src={load} alt='load'/></div>   
         </div>
      );
   }
}
export default Inventarioadmin;